import React from 'react';
import { connect } from 'react-redux';

import { Text } from '@zillow/constellation';

import format from 'date-fns/format';

// containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

import LoadingConstants from 'app/shared/constants/LoadingConstants';

import UserManagementActions from 'app/shared/actions/UserManagementActions';

// Components
import HeadWrapper from 'app/shared/components/HeadWrapper';
import TableMFH from 'app/shared/components/TableMFH';

// Stylesheets
import './style.scss';

const columnConfig = [
    {
        width: 2,
        dataKey: 'date',
        header: 'Activity Date',
        renderer: (data) => {
            const date = new Date(parseFloat(data.created));
            return (
                <div>
                    <div>{format(date, 'M/DD/YYYY')}</div>
                    <div>{format(date, 'hh:mm a')}</div>
                </div>
            );
        },
    },
    {
        width: 3,
        dataKey: 'changedBy',
        header: 'Changed by',
        align: 'center',
        renderer: (data) => {
            switch (data.changedByUserType) {
                case 'datarouterUser':
                case 'privacyRequest':
                case 'automatedJob':
                case 'impersonatedUser':
                    return 'Zillow Support';
                case 'rentalManagerUser':
                case 'invitee':
                    return data.changedByUserId;
                default:
                    return data.changedByUserId;
            }
        },
    },
    {
        width: 3,
        dataKey: 'user',
        header: 'Which user',
        align: 'center',
        renderer: (data) => {
            switch (data.activityType) {
                case 'createdCompany':
                case 'changedCompanyName':
                    return '-';
                case 'sentInvitation':
                    return data.newValue;
                default:
                    return data.changedUserEmail || data.changedUserId;
            }
        },
    },
    {
        width: 4,
        dataKey: 'description',
        header: 'Changed',
        align: 'center',
        renderer: (data) => {
            switch (data.activityType) {
                case 'createdCompany':
                    return 'Created Company';
                case 'changedCompanyName':
                    return `Changed Company Name: ${data.newValue}`;
                case 'addedInitialUser':
                    return 'Added User';
                case 'impersonatedUser':
                    return 'Impersonated User';
                case 'sentInvitation':
                    return 'Sent invitation';
                case 'removedUser':
                    return 'Removed User from Company';
                case 'cancelledInvitation':
                    return 'Cancelled Invitation';
                case 'updatedInvitation':
                    return 'Updated Invitation';
                case 'acceptedInvitation':
                    return 'Accepted Invitation';
                case 'declinedInvitation':
                    return 'Declined Invitation';
                case 'addedPropertyToCompany':
                    return 'Added Property';
                case 'removedPropertyFromCompany':
                    return 'Removed Property';
                case 'addedPermission':
                    return 'Added Permission';
                case 'removedPermission':
                    return 'Removed Permission';
                case 'addedPropertyAccess':
                    return 'Added Property Access';
                case 'removedPropertyAccess':
                    return 'Removed Property Access';
                case 'grantedFullPortfolioAccess':
                    return 'Granted Full Portfolio Access';
                case 'removedFullPortfolioAccess':
                    return 'Removed Full Portfolio Access';
                default:
                    return data.newValue;
            }
        },
    },
];

const propTypes = {};

const ActivityHistoryPage = ({
    logs,
    dispatch,
    loadingState,
    hasMoreData,
}) => {
    React.useEffect(() => {
        dispatch(UserManagementActions.getActivityHistory());
        return () => dispatch(UserManagementActions.initActivityHistory());
    }, []);

    const renderEmptyBanner = () => {
        if (logs.length === 0 && loadingState === LoadingConstants.SUCCESS) {
            return <Text className="empty-message">No activity found</Text>;
        }
        return null;
    };

    const handleInfiniteScroll = (isVisible) => {
        if (isVisible && hasMoreData) {
            dispatch(UserManagementActions.getActivityHistory());
        }
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <div className="ActivityHistoryPage">
                <HeadWrapper title="Users" />
                <TableMFH
                    columnConfig={columnConfig}
                    data={logs}
                    idKey="id"
                    hasMoreData={hasMoreData}
                    isLoading={loadingState === LoadingConstants.LOADING || loadingState === LoadingConstants.INITIAL}
                    handleLoadMoreData={handleInfiniteScroll}
                />
                {renderEmptyBanner()}
            </div>
        </AuthCheckWrapper>
    );
};

const mapStateToProps = state => ({
    logs: state.userManagement.activityHistory.logs,
    loadingState: state.userManagement.activityHistory.loadingState,
    hasMoreData: state.userManagement.activityHistory.hasMoreData,
});

ActivityHistoryPage.propTypes = propTypes;

export { ActivityHistoryPage };
export default connect(mapStateToProps)(ActivityHistoryPage);
